<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { BookmarkIcon } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { useGetElementalInfosQuery } from '~~/src/composables/query/elementals/useGetElementalInfosQuery'
import { cn } from '~~/src/utils'
const props = defineProps<Props>()
defineEmits<{
  (name: 'click', event: MouseEvent): void
}>()
defineOptions({
  name: 'SaveElementalButton',
})

interface Props {
  isSaved?: boolean
  disabled?: boolean
  elementalId?: string
  classIcon?: HTMLAttributes['class']
  feedView?: boolean
}

const elementalId = toRef(props, 'elementalId')
const user = useUser()
const enabled = computed(() => !!elementalId.value && !!user.value?.id)

const { data, isLoading } = useGetElementalInfosQuery({ id: elementalId, query: { fields: 'full' } }, { enabled })
</script>

<template>
  <Button
    variant="snack-ghost"
    :size="feedView ? 'sm' : 'icon'"
    type="button"
    class="text-soft-black bg-white"
    :class="feedView ? 'rounded' : 'rounded-full'"
    :disabled="isLoading"
    @click="$emit('click', $event)"
  >
    <slot>
      <BookmarkIcon
        class="w-5 h-5" :class="[cn('w-5 h-5', classIcon), {
          'fill-softBlack': data?.isSaved,
        }]"
      />
    </slot>
    <slot name="count" />
  </Button>
</template>
